import * as Sentry from '@sentry/browser';
import { JL } from 'jsnlog';
import { Integrations } from '@sentry/tracing';
import common from './common/common';
const configHelper = require('./config/index');

const initTracing = () => {
  const site = common.getSite();
  if (configHelper.getConfig().debug === false) {
    Sentry.init({
      dsn: configHelper.getConfig().tracingUrl,
      integrations: [new Integrations.BrowserTracing()],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: NODE_ENV.toLowerCase() === 'development' ? 1.0 : 0.5,
      environment: NODE_ENV,
    });
    Sentry.setTag('SITE', site);
    Sentry.setTag('getSiteUrl', common.getSiteUrl());
    Sentry.setTag('lang', common.getLang());
    Sentry.setTag('isTouch', common.isTouch());
    Sentry.setTag('isDesktop', common.isDesktop());
  }
};
let initializedLoggers = [];
const _initJsNlog = ({ loggerName }) => {
  if (initializedLoggers.indexOf(loggerName) === -1) {
    const defaultLoggingUrl = window.$pathBase + 'jsnlog.logger';
    var appender = JL.createAjaxAppender('mycustomappender.' + loggerName);
    var consoleAppender = JL.createConsoleAppender(
      'consoleAppender.' + loggerName,
    );
    appender.setOptions({
      bufferSize: 80,
      maxBatchSize: 80,
      url: defaultLoggingUrl,
    });
    JL.setOptions({
      defaultAjaxUrl: defaultLoggingUrl,
    });
    JL(loggerName).setOptions({
      appenders: [appender, consoleAppender],
    });

    if (typeof window !== 'undefined') {
      window.onerror = function (msg, url, line, column, error) {
        let sourceUrl =
          window && window.location && window.location.href
            ? `${url} -- ${window.location.href}`
            : url;
        let reasonMessage = error && error.message ? error.message : msg;

        JL('onerrorLogger').fatal(
          `onerror. Reason message: ${reasonMessage} SourceUrl: ${sourceUrl} url: ${url}, line: ${line}`,
        );
        return false;
      };
      window.onunhandledrejection = function (event) {
        // How to test this handler: window.setTimeout(function() {throw new Error('abc')}, 0);
        let sourceUrl =
          window && window.location && window.location.href
            ? ` window.location.href: ${window.location.href}`
            : '';
        let reasonMessage =
          event.reason && event.reason.errorMessage
            ? event.reason.errorMessage
            : '';

        // Loggo solo in caso di errore diverso da 'Failed to fetch', perchè per quello abbiamo gia' onerror che logga e dovrebbe essere sufficiente per capire cosa e' successo.
        if (reasonMessage !== 'Failed to fetch') {
          JL('onerrorLogger').fatal(
            `unhandledrejection. Reason message: ${reasonMessage} SourceUrl: ${sourceUrl}`,
          );
        }
        console.error('unhandledrejection', event);
        return false;
      };
    }
    initializedLoggers.push(loggerName);
  }
};
const logDebug = function (...args) {
  _initJsNlog({ loggerName: 'jsnlogfile' });
  JL('jsnlogfile').debug(args);
};
const logInfo = function (...args) {
  _initJsNlog({ loggerName: 'jsnlogfile' });
  JL('jsnlogfile').info(args);
};
const logEvent = function (...args) {
  _initJsNlog({ loggerName: 'jsnlogfile' });
  _initJsNlog({ loggerName: 'jsnlogeventfile' });
  JL('jsnlogeventfile').debug(args);
  JL('jsnlogfile').debug(args);
};
const logWarn = function (...args) {
  console.warn(args);
  _initJsNlog({ loggerName: 'jsnlogfile' });
  JL('jsnlogfile').warn(args);
};
const logError = function (...args) {
  console.error(args);
  _initJsNlog({ loggerName: 'jsnlogfile' });
  JL('jsnlogfile').error(args);
};
export { initTracing, logDebug, logInfo, logWarn, logError, logEvent };
